import { useRef } from "react";
import { motion, useReducedMotion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 44, className = "", once = true, ...rest }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-8% 0px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Lines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12, animate = true }) {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-8% 0px" });
  const noAnim = reduce || !animate;
  const show = noAnim || animate === "load" || inView;
  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={noAnim ? false : { y: "115%" }}
            animate={show ? { y: "0%" } : { y: "115%" }}
            transition={{ duration: 1.05, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function SectionTag({ index, label, light = false }) {
  return (
    <Reveal className={`flex items-center gap-4 ${light ? "text-zinc-500" : "text-zinc-400"}`} y={20}>
      <span className="h-px w-10 bg-swapa-yellow" aria-hidden="true" />
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-swapa-yellow">{index}</span>
      <span className="font-mono text-xs uppercase tracking-[0.25em]">{label}</span>
    </Reveal>
  );
}

export function Marquee({ items, className = "" }) {
  const row = items.concat(items);
  return (
    <div className={`relative overflow-hidden border-y border-white/10 py-5 ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee-slow items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl sm:text-3xl font-800 font-bold uppercase tracking-tight text-white/90">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-swapa-yellow" />
          </span>
        ))}
      </div>
    </div>
  );
}
